export var norm = function (value, min, max) {
    return (value - min) / (max - min);
};
export var lerp = function (normal, min, max) {
    return (max - min) * normal + min;
};
export var clamp = function (value, min, max) {
    return Math.min(Math.max(value, Math.min(min, max)), Math.max(min, max));
};
export var map = function (value, sourceMin, sourceMax, destMin, destMax) { return lerp(norm(value, sourceMin, sourceMax), destMin, destMax); };
export var inRange = function (value, min, max) {
    return value >= Math.min(min, max) && value <= Math.max(min, max);
};
//# sourceMappingURL=math.js.map